import React from 'react';
import UserForm from '../../../components/forms/UserForm';

export default function UsersCreatePage() {
  return <UserForm />;
}
